import React from 'react'
import { useField } from 'formik'
import { DatePickerFieldProps } from './index'
import { InputFieldContainer } from './styles'
import { FormikDatePicker } from 'particles/DatePicker'
import { getTimeZonedDateNow, parseJsDate } from 'services/dates'

const DatePickerField: React.FC<DatePickerFieldProps> = ({
    name = '',
    title,
    subtitle,
    isRequired = false,
    isDisable,
    isReadOnly = false,
    readOnlyForPastDate = false,
    country,
    identifier,
    ...props
}) => {
    const [, meta] = useField(name)
    const currentValueDate = new Date(parseJsDate(meta.initialValue, false))
    const currentDate = getTimeZonedDateNow(country)
    const displayReadOnly = isReadOnly
        ? isReadOnly
        : readOnlyForPastDate && meta.initialValue && currentValueDate < currentDate

    return (
        <InputFieldContainer>
            <FormikDatePicker
                name={name}
                size={'m'}
                isDisabled={isDisable}
                isReadOnly={displayReadOnly}
                isRequired={isRequired}
                country={country}
                label={title}
                subtext={subtitle}
                identifier={identifier}
                placeholder="DD/MM/YYYY"
            />
        </InputFieldContainer>
    )
}
export default DatePickerField
